import { ArrowLeftOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Col, Row, Spin } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./logs-table.scss";
import Meta from "../../../../Meta";
import { MetaTitle } from "../../../../common/constants/constants";
import { service } from "../../../../services";
import {
  ClientSideRowModelModule,
  DateFilterModule,
  ModuleRegistry,
  NumberFilterModule,
  TextFilterModule,
  ValidationModule,
  InfiniteRowModelModule,
  PaginationModule
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  ValidationModule,
  InfiniteRowModelModule,
  PaginationModule
]);

const LogsTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const gridRef = useRef();
  const [loader, setLoader] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [noData, setNoData] = useState(false);
  const perPage = 1000;

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const defaultColDef = useMemo(() => ({
    width: 220,
    editable: false,
    filter: "agTextColumnFilter",
    floatingFilter: true,
    // resizable: true,
    flex: 1
  }), []);

  const defaultColGroupDef = useMemo(() => ({
    marryChildren: true,
  }), []);

  const columnTypes = useMemo(() => ({
    numberColumn: { width: "100%", filter: "agNumberColumnFilter" },
    medalColumn: { width: "100%", columnGroupShow: "open", filter: false },
    nonEditableColumn: { editable: false },
    dateColumn: {
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const dateParts = cellValue.split("/");
          const day = Number(dateParts[0]);
          const month = Number(dateParts[1]) - 1;
          const year = Number(dateParts[2]);
          const cellDate = new Date(year, month, day);
          if (cellDate < filterLocalDateAtMidnight) return -1;
          if (cellDate > filterLocalDateAtMidnight) return 1;
          return 0;
        },
      },
    },
  }), []);

  // Prepare datasource for infinite row model
  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    if (location?.state?.data?.length > 0) {
      const data = location.state.data;
      const ds = {
        getRows: (gridParams) => {
          setLoader(true);
          const page = gridParams.endRow / perPage;
          // Extract filter and sort info
          const filterModel = gridParams.filterModel;
          const sortModel = gridParams.sortModel;
          const payload = {
            page,
            size: perPage,
            startDate: data[0]?.startDate,
            endDate: data[0]?.endDate,
            databaseId: data[0]?.databaseId,
            filterModel,
            sortModel,
          };
          service?.falconViewLogs(payload).then((res) => {
            if (res?.success === false) {
              gridParams.successCallback([], 0);
              setNoData(true);
              setLoader(false);
            } else {
              gridParams.successCallback(res?.data?.data, parseInt(res?.data?.totalCount));
              if (res?.data?.data?.length > 0) {
                let keys = Object.keys(res.data.data[0]);
                // Remove the first key from the array
                keys = keys.slice(1);
                const colDefs = keys.map((key) => ({ field: key }));
                setColumnDefs(colDefs);
                setNoData(false);
              } else {
                setNoData(true);
              }
              setLoader(false);
            }
          });
        },
      };
      setDataSource(ds);
    } else {
      setNoData(true);
      setLoader(false);
    }
  }, [location]);

  return (
    <>
      <Meta name={MetaTitle.FalconLogsDetails} />
      {loader && <Spin />}
      <div className="logs-H">
        <h1 className="page-container-title-logsdetails">
          <ArrowLeftOutlined
            onClick={() => navigate("/falcon/logs", { state: location?.state?.data })}
            className="logs-Arrow outline"
          />
          {location?.state?.data?.[0]?.databasename} Logs
        </h1>
      </div>
      <Row>
        <div className="ag-theme-alpine1 box" style={{ width: "98.4%" }}>
          <div style={containerStyle}>
            <div className="paginaton-grid-tab ag-theme-alpine1 box" style={{ boxSizing: "border-box" }}>
              <div style={gridStyle} className="ag-theme-alpine ag-theme-alpine1 box">
                <AgGridReact
                  ref={gridRef}
                  pagination={true}
                  rowModelType="infinite"
                  paginationPageSize={perPage}
                  cacheBlockSize={perPage}
                  datasource={dataSource}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  defaultColGroupDef={defaultColGroupDef}
                  columnTypes={columnTypes}
                  theme="legacy"
                  paginationPageSizeSelector={[10, 25, 50, 100, 500, 1000]}
                />
              </div>
              {noData && !loader && (
                <div style={{ left: "5%", top: "10%" }} className="ag-overlay">
                  <div className="ag-overlay-panel">
                    <div className="ag-overlay-wrapper">
                      <span className="ag-overlay-center">No Data Found...</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Row>
    </>
  );
};

export default LogsTable;